export const BUSINESS_PHONE = "919180180056";
export const UNIT_PRICE = 1099;
export const GIFT_SET = { jars: 3, price: 2999, savings: 1099 * 3 - 2999 };
export const EMAIL = "enchantedglim4@gmail.com";
export const CITY = "Bengaluru";
export const INSTAGRAM_URL = "https://instagram.com/enchantedglim4";
export const INSTAGRAM_HANDLE = "@enchantedglim4";

export const SCENTS = [
  {
    id: "rose-marry",
    name: "Rose Marry",
    benefit: "Stress & anxiety relief",
    notes: "Damask rose, fresh rosemary, soft musk",
    tint: "#E3B7BA",
    tag: "Bestseller",
    img: "/images/scent-rose.webp",
  },
  {
    id: "lavender-calm",
    name: "Lavender Calm",
    benefit: "Deep sleep & relaxation",
    notes: "French lavender, bergamot, warm vanilla",
    tint: "#B9A8D6",
    tag: null,
    img: "/images/scent-lavender.webp",
  },
  {
    id: "sandalwood-mist",
    name: "Sandalwood Mist",
    benefit: "Grounding & focus",
    notes: "Mysore sandalwood, cedarwood, amber",
    tint: "#D6B490",
    tag: null,
    img: "/images/scent-sandalwood.webp",
  },
  {
    id: "vanilla",
    name: "Vanilla Bean",
    benefit: "Calming & restful comfort",
    notes: "Madagascar vanilla, tonka bean, soft amber",
    tint: "#E7D3AC",
    tag: null,
    img: "/images/scent-vanilla.webp",
  },
];

export const ASSORTED = { id: "assorted", name: "Assorted (Mix of All)" };

export const waLink = ({ scent = "Rose Marry", pack = "single", qty = 1, giftScents = null } = {}) => {
  const isGift = pack === "gift";
  const total = (isGift ? GIFT_SET.price : UNIT_PRICE) * qty;
  const item = isGift
    ? `${qty} x Festive Gift Set of ${GIFT_SET.jars} jars (${giftScents?.length ? giftScents.join(", ") : scent})`
    : `${qty} x ${scent} 5-inch Perforated Wellness Candle`;
  return `https://wa.me/${BUSINESS_PHONE}?text=${encodeURIComponent(
    `Hi Enchanted Glim, I would like to order ${item} (Est. Total: ₹${total.toLocaleString("en-IN")}).`
  )}`;
};

export const telLink = `tel:+${BUSINESS_PHONE}`;
